<template>
    <v-app class="tw-bg-purple-900">
        <v-main>
            <v-container fluid class="tw-p-0">
                <slot /> 
            </v-container>
            <snack-bar/>
        </v-main>
    </v-app>
</template>

<script>
import SnackBar from '@/components/SnackBar';
export default {
    components: {SnackBar}
}
</script>

<style scoped>
</style>